<!--
Author: TangChen
Date: 2018-09-25
Desc: 绘制提示信息卡片，为公共组件
 -->
<template>
    <div class="comp-hint-card comp clear">
        <div class="pwd-way-con">
            <span class="pwd-way-img" :class="[data.cla]">
                <i :class="data.icon" />
            </span>
            <div class="pwd-way-intr">
                <h3>{{ data.tit }}</h3>
                <p>{{ data.text }}</p>
            </div>
        </div>
        <div v-if="data.btnArr" class="pwd-way-btn">
            <el-button
                v-for="(btn,index) in data.btnArr"
                :key="index"
                :class="{'btn-m':data.btnArr.length>1}"
                type="primary"
                :disabled="btn.disabled"
                v-on:click="returnBtn(btn.page,btn.way)"
            >
                {{ btn.btn }}
            </el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: "HintCard",
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
        };
    },
    methods: {
        returnBtn (page, way) {
            this.$emit("btn-click", page, way);
        }
    }
};
</script>
<style lang="scss">
@import '../../assets/css/varibles';
.comp-hint-card {
  padding: 18px 30px 20px 26px;
  border: 1px solid $border-color3;
  border-radius: 6px 6px;
  box-shadow: 0 0 4px 0 $border-color3;
  margin-top: 28px;
  .pwd-way-con {
    float: left;
    .pwd-way-img {
      width: 82px;
      height: 82px;
      display: inline-block;
      background: $bg7;
      border-radius: 100% 100%;
      -webkit-border-radius: 100% 100%;
      text-align: center;
      color: $text-color6;
      line-height: 82px;
      font-size: $f40;
      vertical-align: middle;
      &.blue {
        background: $bg8;
      }
      &.green{
        background: $bg11;
      }
      &.purple{
        background: $bg12;
      }
      &.b-yellow{
        background: $bg16;
      }
      &.b-red{
        background: $bg17;
      }
      &.yellow{
        background: $color-a;
      }
      &.black{
        background: #FFDAB9;
      }
    }
    .pwd-way-intr {
      padding-left: 20px;
      display: inline-block;
      vertical-align: middle;
      color: $text-color3;
      line-height: 30px;
      h3 {
        color: $text-color2;
        font-size: $f16;
        font-weight: normal;
      }
    }
  }
  .pwd-way-btn {
    float: right;
    padding-top: 21px;
    .el-button {
      min-width: 170px;
      &.is-disabled{background-color: $bg9;border-color:$bg9;}
      &.btn-m{min-width: 80px;}
    }
  }
}
</style>
